import { Row } from 'antd';
import Box from 'components/Box';
import Text from 'components/Text';
import Sidebar from 'components/layout/Sidebar';
import colorTheme from 'constants/color';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import ticketListActions from 'features/ticketList/services/actions';
import ticketListSelectors from 'features/ticketList/services/selectors';
import { IApiReportCreditCard } from 'features/ticketList/services/types/api';
import { ICreditCardFilterFunction } from 'features/ticketList/services/types/creditCard';
import { remove } from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import HeaderTickets from './components/HeaderTickets';
import SummaryCreditCards from './components/SummaryCreditCards';
import TabTicketByParams from './components/Tabs/TabTicketByParams';
import ListTicketPageStyled from './styles';
import shopSelectors from 'services/shop/selectors';
// import TicketFilterV2 from './components/TabsV2/Filter';
import CreditCardTicketTable from './CreditCardPageV2.TicketTable';
import CreditCardFilter from './CreditCardPageV2.Filter';
type IListTicketPageProps = any;
const CreditCardPage: React.FC<IListTicketPageProps> = () => {
  const versionUI = shopSelectors.data.versionUI();
  const allSetting = shopSelectors.data.allSetting();
  const v2 = versionUI === 'V2';
  const dispatch = useAppDispatch();
  const adjustTipStore = ticketListSelectors.adjustTip();
  const params = ticketListSelectors.creditCardTicketsTableData.params();
  useEffect(() => {
    dispatch(ticketListActions.doInit());

    const _params: IApiReportCreditCard = {
      statuses: ['CLOSED', 'REFUND', 'VOID'],
      page: 1,
      size: 10,
      startDate: moment().format(DATE_FORMAT),
      endDate: moment().format(DATE_FORMAT),
    };
    // dispatch(ticketListActions.setVisibleCusPhone(true));
    // dispatch(ticketListActions.getSummaryCreditCards.fetch({ startDate: _params.startDate || '', endDate: _params.endDate || '' }));
    dispatch(ticketListActions.setCreditCardParams(_params));
  }, []);

  const disableAdjustTip = useMemo(() => {
    return !adjustTipStore.some(o => !!o.tip);
  }, [adjustTipStore]);

  const creditCardFilter: ICreditCardFilterFunction = ({ endDate, startDate }) => {
    dispatch(ticketListActions.getSummaryCreditCards.fetch({ startDate, endDate }));
  };

  const handleParentButtonClick = () => {
    // call action in store list
    dispatch(ticketListActions.adjustTip.fetch({}));
  };

  const handleFilterStatus = (_status: TicketStatus) => () => {
      const statusArr = [...(params.statuses || [])];
      if (statusArr?.indexOf(_status) !== -1) {
        remove(statusArr, (o) => o === _status);
      } else {
        // @ts-ignore
        statusArr.push(_status);
      }
      const _params: IApiReportCreditCard = {
        ...params,
        statuses: statusArr,
        page: 1,
      };
      dispatch(ticketListActions.setCreditCardParams(_params));
    };


  return (
    <>
      <ListTicketPageStyled>
        <Sidebar />
        <BodyStyled>
          <Row align={'middle'} style={{ gap: '0.5rem', marginBottom: '1rem', marginTop: v2 ? 16 : 0 }}>
            <Box mr="2">
              <Text variant="H5">Credit Cards</Text>
            </Box>
            <div style={{ flex: 1 }} />
            {v2 ? <CreditCardFilter onFilter={creditCardFilter} /> : <HeaderTickets isCreditPage creditCardFilter={creditCardFilter} />}
            {/* <AdjustButtonStyled
              icon={<Icon type="adjustTipAll" />}
              onClick={handleParentButtonClick}
              disabled={disableAdjustTip}
              className={v2 ? 'v2' : ''}
            >
              Adjust Tip All
            </AdjustButtonStyled> */}
          </Row>
          {allSetting?.displayDashboardCreditCard && (
            <Row style={{ width: '100%', gap: '10%', marginBottom: '1rem' }} justify={'space-between'} align={'bottom'}>
              <SummaryCreditCards v2={v2} />
            </Row>
          )}
          <Row style={{ gap: '0.5rem', margin: '0', marginBottom: '0.5rem' }} justify={'end'}>
            <TicketStatusCheckBox
              status='CLOSED'
              selected={params.statuses?.includes('CLOSED')}
              onClick={handleFilterStatus('CLOSED')}
            />
            <TicketStatusCheckBox
              status='VOID'
              selected={params.statuses?.includes('VOID')}
              onClick={handleFilterStatus('VOID')}
            />
            <TicketStatusCheckBox
              status='REFUND'
              selected={params.statuses?.includes('REFUND')}
              onClick={handleFilterStatus('REFUND')}
            />
          </Row>
          <div className="container-ticket">
            { v2 ?
            (
              <CreditCardTicketTableStyled>
                <CreditCardTicketTable />
              </CreditCardTicketTableStyled>
            ) :
            <TabTicketByParams v2={v2} tableKey={'CLOSED'} isCreditPage />
          }
          </div>
        </BodyStyled>
      </ListTicketPageStyled>
    </>
  );
};

export default CreditCardPage;

const BodyStyled = styled.div`
  flex-grow: 1;
  height: 100vh;
  overflow: auto;
  background-color: ${colorTheme.fill_3};
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  .out-box-circle-status {
    border: 1px solid #ccd4dc;
    gap: 8px;
    padding-top: 4px;
    padding-right: 16px;
    padding-bottom: 4px;
    padding-left: 16px;
    border-radius: 100px;
    border-width: 1px;
  }
  .circle-status {
    background: #efefef;
    border-radius: 5px;
    border: 1px solid #ccd4dc;
    margin-right: 4px;
  }
  .check-box-size {
    width: 33px;
    height: 32px;
  }
  .container-ticket {
    flex: 1;
    position: relative;
    margin-bottom: 12px;
  }
  .ticket-filter-v2-container {
    flex: 1;
  }
`;

const CreditCardTicketTableStyled = styled.div`
  position: absolute;
  inset: 0;
  overflow: auto;

  .ant-table-wrapper {
    .ant-table {
      .ant-table-container {
        .ant-table-content {
          max-height: unset;
          overflow: unset;
        }
      }
    }
  }

  .ant-table-pagination {
    position: sticky;
    bottom: 0;
  }
`;

// const AdjustButtonStyled = styled(Button)`
//   height: 3.5rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   align-self: flex-end;
//   gap: 0.175rem;
//   padding: 0 1rem;
//   background-color: #6fabb6;
//   border-color: #6fabb6 !important;
//   box-shadow: -1px 1px 4px 0px #0000001a inset, 0px 4px 4px 0px #00000040;
//   font-size: 1rem;
//   font-weight: 600;
//   line-height: 22px;
//   letter-spacing: 0em;
//   text-align: center;
//   color: white !important;

//   &:hover {
//     opacity: 0.7;
//     transition: opacity 0.3s; // smooth transition for the hover effect
//   }
//   &:disabled {
//     background-color: #6fabb6 !important;
//     border-color: #6fabb6!important;
//     opacity: 0.7;
//   }

//   &.v2 {
//     border-radius: 4px;
//     background: #C6E9EF;
//     border: none !important;
//     box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
//     span {
//       color: #1D2129;
//     }
//     svg path {
//       fill: #1D2129;
//     }

//     &:disabled {
//       background-color: #C6E9EF !important;
//       border-color: none !important;
//       opacity: 0.7;
//     }
//   }
// `;

type TicketStatus = 'CLOSED' | 'REFUND' | 'VOID';

const getStyleColor = (status: TicketStatus) => {
  switch (status) {
    case 'CLOSED':
      return { background: '#FFF', border: '1px solid #CCD4DC' };
    case 'VOID':
      return { background: '#F7FFFD', border: '1px solid #346751' };
    case 'REFUND':
      return { background: '#FFFAF8', border: '1px solid #C84B31' };
    default:
      return { background: '#FFF', border: '1px solid #CCD4DC' };
  }
};

const getLabel = (status: TicketStatus) => {
  switch (status) {
    case 'CLOSED':
      return ' Closed';
    case 'VOID':
      return ' Voided';
    case 'REFUND':
      return ' Refunded';
    default:
      return '';
  }
};

type ITicketStatusCheckBoxProps = {
  status: TicketStatus;
  selected?: boolean;
  onClick?: () => void;
};
const TicketStatusCheckBox = ({
  status,
  selected,
  onClick,
}: ITicketStatusCheckBoxProps) => {
  return (
    <button onClick={onClick}>
      <Row
        align={'middle'}
        className='out-box-circle-status'
        style={getStyleColor(status)}
      >
        <Row align={'middle'} justify={'center'} className='circle-status'>
          <div className='check-box-size'>
            {selected ? (
              <svg
                width='33'
                height='32'
                viewBox='0 0 33 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect x='0.5' width='32' height='32' rx='3' fill='#232F3E' />
                <path
                  d='M13.9743 22.6666C13.6186 22.6666 13.2806 22.5178 13.0316 22.2573L7.99794 16.9928C7.48213 16.4534 7.48213 15.5604 7.99794 15.021C8.51375 14.4815 9.36751 14.4815 9.88332 15.021L13.9743 19.2995L23.1166 9.73786C23.6324 9.19838 24.4862 9.19838 25.002 9.73786C25.5178 10.2773 25.5178 11.1702 25.002 11.7097L14.917 22.2573C14.668 22.5178 14.3301 22.6666 13.9743 22.6666Z'
                  fill='white'
                />
              </svg>
            ) : null}
          </div>
        </Row>
        <Text variant='CONTENT_2' color='text_3'>
          {getLabel(status)}
        </Text>
      </Row>
    </button>
  );
};

